import clone from 'lodash/clone';

function PayrollNode(resource, parameters, parent) {
  this.key = parameters.key
  this.value = resource.value
  this.extern_bonus = resource.extern_bonus
  this.total_period = resource.total_period
  this.details = resource.details

  if (typeof (parent) !== 'undefined') {
    if (typeof (parent.context) !== 'undefined')
      this.context = clone(parent.context)
    else this.context = {}
    this.context[parent.key] = parent
  }

  if (typeof (parameters.childConstructor) !== 'undefined') {
    this[parameters.childsKey] = resource.breakdown
      .map(x => new (parameters.childConstructor)(x, this))
  }
}

export function payrollInheritedNode(parameters, c, p) {
  function Payroll() { }
  Payroll.prototype = new PayrollNode(c, parameters, p)
  
  return new Payroll()
}
